import { render, staticRenderFns } from "./myOrdersPage.vue?vue&type=template&id=319d0dd5&scoped=true&"
import script from "./myOrdersPage.vue?vue&type=script&lang=ts&"
export * from "./myOrdersPage.vue?vue&type=script&lang=ts&"
import style0 from "./myOrdersPage.vue?vue&type=style&index=0&id=319d0dd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319d0dd5",
  null
  
)

export default component.exports